export default "__VITE_ASSET__5472ab7a__"